import React, { useEffect,useState } from 'react'
import { Link, useParams,useNavigate } from 'react-router-dom';
import { Table, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import $ from 'jquery';
import { useCSVDownloader } from 'react-papaparse';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import moment from 'moment';

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const SellerPayments = () => {
    let navigate = useNavigate();
    const { CSVDownloader } = useCSVDownloader();

    const [sellerPayments, setSellerPayments] = useState([]);
    const [paymentList, setPaymentList] = useState([]);
    const [approveButton, setApproveButton] = useState(false);
    const [pushPaymentButton, setPushPaymentButton] = useState(false);
    const [modal, setModal] = useState(false);
    const [orderDetails, setOrderDetails] = useState([]);
    const [vendorPayment, setVendorPayment] = useState(0);
    const [addPaymentDate, setAddPaymentDate] = useState(false);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

    useEffect(()=>{
        checkAccess();
    },[])
    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
        } else {
            setUserRights(rights);
        }
    }

	const fetchSellerPayments = async () => {
        if ($('#payment_for').val() == "vendor") {
            setVendorPayment(1);
        } else {
            setVendorPayment(0);
        }
        let fetchType = 0;
        if ($('#fetch_approved').is(':checked')) {
            fetchType = 1;
        } else if ($('#fetch_done_payments').is(':checked')) {
            fetchType = 2;
        }
		const data = {
            start_date: $('#start_date').val(),
            end_date: $('#end_date').val(),
            payment_for: $('#payment_for').val(),
            fetch_approved: fetchType,
            order_type: $('#order_type').val()
        }
		let response = await common.apiRequest('post', '/admin/fetch-seller-payments', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                setSellerPayments(response.data.data);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
	}

    const addToPaymentList = async (e, data) => {
        let markAsPaid = $('#fetch_approved').is(':checked') ? 1 : 0;
        let list = paymentList;
        if (e.target.checked) {
            list.push(data);
        } else {
            list = list.filter(function( obj ) {
                return obj.seller_id !== data.seller_id;
            });
        }
        if (list.length > 0) {
            if (markAsPaid) {
                setPushPaymentButton(true);
                setApproveButton(false);
              } else {
                setPushPaymentButton(false);
                setApproveButton(true);
              }
            $('#start_date').prop('disabled', true);
            $('#end_date').prop('disabled', true);
            $('#payment_for').prop('disabled', true);
            $('#all').prop('disabled', true);
            $('#fetch_approved').prop('disabled', true);
            $('#fetch_done_payments').prop('disabled', true);
            $('#submit_button').prop('disabled', true);
        } else {
            setApproveButton(false);
            setPushPaymentButton(false);
            $('#start_date').prop('disabled', false);
            $('#end_date').prop('disabled', false);
            $('#payment_for').prop('disabled', false);
            $('#all').prop('disabled', false);
            $('#fetch_approved').prop('disabled', false);
            $('#fetch_done_payments').prop('disabled', false);
            $('#submit_button').prop('disabled', false);
        }
        setPaymentList(list);
    }

    const approvePayment = async () => {
        let data = [];
        paymentList.map((payment) => {
            let tempData = {};
            tempData.seller_id = payment.seller_id;
            tempData.order_item_ids = vendorPayment ? payment.logistics_order_ids : payment.order_item_ids;
            tempData.order_payment_amount = payment.net_payment;
            tempData.payment_status = 'in_process';
            tempData.type = vendorPayment ? 'vendor' : 'supplier';
            data.push(tempData);
        });
        let finalData = {
            "action": "create",
            "data": data,
            "vendor_payment": vendorPayment
        }
        let response = await common.apiRequest('post', '/admin/crud-seller-payment', finalData);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                alert(response.data.message);
                setApproveButton(false);
                setPaymentList([]);
                $('.seller-payment-checkbox').prop('checked', false);
                $('#start_date').prop('disabled', false);
                $('#end_date').prop('disabled', false);
                $('#payment_for').prop('disabled', false);
                $('#all').prop('disabled', false);
                $('#fetch_approved').prop('disabled', false);
                $('#fetch_done_payments').prop('disabled', false);
                $('#submit_button').prop('disabled', false);
                fetchSellerPayments();
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
    }

    const updatePaymentDate = async () => {
        $('#push-payment-button').prop('disabled', true);
        let orderItemIds = [];
        for (const list of paymentList) {
            if ($('#payment_for').val() == "supplier") {
                orderItemIds = orderItemIds.concat(list.order_item_ids.split(","));
            } else if ($('#payment_for').val() == "vendor") {
                orderItemIds = orderItemIds.concat(list.logistics_order_ids.split(","));
            }
        }
        let finalData = {
            "action": "update",
            "payment_date": moment($('#payment-date').val()).format("YYYY-MM-DD HH:mm:ss"),
            "order_item_ids": orderItemIds,
            "type": $('#payment_for').val()
        }
        let response = await common.apiRequest('post', '/admin/update-payment-date', finalData);
        if (response.status == 200) {
        if (response.data.code == 'success') {
            alert(response.data.message);
            setPushPaymentButton(false);
            setPaymentList([]);
            setAddPaymentDate(!addPaymentDate);
            $('input[type="checkbox"]').prop('checked', false);
            $('#start_date').prop('disabled', false);
            $('#end_date').prop('disabled', false);
            $('#payment_for').prop('disabled', false);
            $('#all').prop('disabled', false);
            $('#fetch_approved').prop('disabled', false);
            $('#fetch_done_payments').prop('disabled', false);
            $('#submit_button').prop('disabled', false);
            fetchSellerPayments();
        } else {
            alert(response.data.error);
        }
        } else {
        alert(response.data.error);
        }
        $('#push-payment-button').prop('disabled', false);
    }

    const exportData = () => {
        const columns = [
            {
                id: 'reg_id',
                displayName: 'Reg Id'
            }, 
            {
                id: 'fist_name',
                displayName: 'First Name'
            }
        ];
    }

    const toggle = () => {
        setModal(!modal);
        setOrderDetails([]);
    }

    const getOrderDetails = async (orderIds, vendorId = 0) => {
        let data = {
            'ids': orderIds,
            'vendor_id': vendorId,
            'vendor_payment': vendorPayment
        }
        let response = await common.apiRequest('post', '/orders/get-order-by-order-id', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
                setOrderDetails(response.data.data);
                setModal(true);
			} else {
                alert(response.data.error);
            }
		} else {
            alert(response.data.error);
		}
    }
    const data = sellerPayments.map((item, index) => ({
        "S.no": index + 1,
        "Reg Id": item.reg_id,
        "First Name": item.first_name,
        "Middle Name": item.middle_name,
        "Last Name": item.last_name,
        "Total Order Amount": common.parseValue (item.total_order_amount, 'float'),
        "Total Taxable Amount": common.parseValue (item.total_taxable_amount, 'float'),
        "Total TCS": common.parseValue (item.total_tcs, 'float'),
        "Net Payment": common.parseValue (item.net_payment, 'float'),
        "Bank Name": item.bank_name,
        "Bank Account No": item.bank_account_no,
        "IFSC Code": item.ifsc_code,
    }));


const handleExportCSV = () => {
    exportToCSV(data, 'seller payment');
}

const handleExportExcel = () => {
    exportToExcel(data, 'seller payment');
}

const handleExportPDF = () => {
    exportToPDF(data, 'seller payment');
}
const orderData = orderDetails.map((data) => {
    let divisionNumber = data?.logistics_order?.order_item_id?.split(',')?.length || 1;
    let returnDivisionNumber = data?.return_logistics_order?.order_item_id?.split(',')?.length || 1;
    let replaceDivisionNumber = data?.replace_logistics_order?.order_item_id?.split(',')?.length || 1;

    return {
        "Order ID": data?.order?.order_id ?? 'NA',
        "Invoice No": data?.order?.invoices
            ? (data.order.invoices.find(invoice => vendorPayment ? invoice.invoice_type === "logistics" : invoice.invoice_type === 'seller_product') || { invoice_no: "" }).invoice_no
            : "",
        "Sale Type": data.offline_sale_id ? 'Offline Sale' : data.service_id ? 'Service Sale' : 'Online Sale',
        "No Return Date": data?.no_return_date || null,
        "Product/Service Name": data?.product_item?.product?.name 
            || data?.offline_sale_product_datum?.product_description 
            || data?.seller_service?.service_name 
            || 'NA',
        "Order Price": vendorPayment ? Number(data?.logistics_order?.order_price || 0) / divisionNumber : data?.order_price ?? 0,
        "Order Status": data?.order_status ?? null,
        "Taxable Value": vendorPayment ? Number(data?.logistics_order?.taxable_value || 0) / divisionNumber : data?.taxable_amount ?? 0,
        "GST Rate": vendorPayment ? data?.logistics_order?.gst_rate ?? 0 : data?.tax_percent ?? 0,
        "Tax Amount": common.parseValue (vendorPayment
            ? (Number(data?.logistics_order?.order_price ?? 0) / divisionNumber - Number(data?.logistics_order?.taxable_value ?? 0) / divisionNumber)
            : (data?.order_price ?? 0) - (data?.taxable_amount ?? 0), 'float'),
        "IGST Percent": vendorPayment 
            ? data?.logistics_order?.igst_percent ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.igst_rate ?? 0 
                : data?.igst_percent ?? 0,
        "IGST Amount": vendorPayment 
            ? Number(data?.logistics_order?.igst || 0) / divisionNumber ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.igst_amount ?? 0 
                : data?.igst ?? 0,
        "CGST Percent": vendorPayment 
            ? data?.logistics_order?.cgst_percent ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.cgst_rate ?? 0 
                : data?.cgst_percent ?? 0,
        "CGST Amount": vendorPayment 
            ? Number(data?.logistics_order?.cgst || 0) / divisionNumber ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.cgst_amount ?? 0 
                : data?.cgst ?? 0,
        "SGST Percent": vendorPayment 
            ? data?.logistics_order?.sgst_percent ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.sgst_utgst_rate ?? 0 
                : data?.sgst_percent ?? 0,
        "SGST Amount": vendorPayment 
            ? Number(data?.logistics_order?.sgst || 0) / divisionNumber ?? 0 
            : data?.offline_sale_id 
                ? data?.offline_sale_product_datum?.sgst_utgst_amount ?? 0 
                : data?.sgst ?? 0,
        "UTGST Percent": vendorPayment ? data?.logistics_order?.utgst_percent ?? 0 : data?.utgst_percent ?? 0,
        "UTGST Amount": vendorPayment ? Number(data?.logistics_order?.utgst || 0) / divisionNumber ?? 0 : data?.utgst ?? 0,
        "Marketing Charges": vendorPayment ? null : data?.marketing_charges ?? 0,
        "Discount": vendorPayment ? null : data?.discount ?? 0,
        "Other Charges": vendorPayment ? null : data?.other_charges ?? 0,
        "Shipment ID": data?.shipment_id ?? 'NA',
        "Tracking No": data?.tracking_no ?? 'NA',
        "TCS Rate": vendorPayment ? data?.logistics_order?.tcs_rate ?? 0 : data?.tcs_rate ?? 0,
        "TCS Amount": vendorPayment ? common.parseValue(Number(data?.logistics_order?.tcs || 0) / divisionNumber ?? 0, 'float') : common.parseValue(data?.tcs, 'float') ?? 0,
        "Bank Charges": vendorPayment ? Number(data?.logistics_order?.bank_charges || 0) / divisionNumber ?? 0 : data?.bank_charges ?? 0,
        "Commission Charges": vendorPayment ? common.parseValue(Number(data?.logistics_order?.commission_charges || 0) / divisionNumber, 'float') ?? 0 : common.parseValue(data?.commission_charges, 'float') ?? 0,
        "Return Order Price": !vendorPayment 
            ? Number(data?.return_logistics_order?.order_price || 0) / Math.max(returnDivisionNumber, 1) 
            : 0,

        "Replace Order Price": !vendorPayment 
            ? Number(data?.replace_logistics_order?.order_price || 0) / Math.max(replaceDivisionNumber, 1) 
            : 0,
        "Vendor Net Payment": vendorPayment 
            ? Number(data?.logistics_order?.vendor_net_payment || 0) / divisionNumber ?? 0 
            : data?.supplier_net_payment ?? 0,
        "Last Updated": data?.updated_at
    };

});

const handleExportCSVs = () => {
    exportToCSV(orderData, 'Seller Payment');
}

const handleExportExcels = () => {
    exportToExcel(orderData, 'Seller Payment');
}

const handleExportPDFs = () => {
    exportToPDF(orderData, 'Seller Payment');
}

  return (
    <>
          
            <h1>Seller Payment</h1>
            <br />
            <div className='row'>
                <div className='col-md-2'>
                    <label>Start Date</label>
                    <input type='date' className='form-control' id="start_date"/><br/>
                    <input type='radio' name='fetch_option' id="all" defaultChecked/> Fetch All&nbsp;&nbsp;
                    <input type='radio' name='fetch_option' id="fetch_approved"/> Fetch Approved&nbsp;&nbsp;
                    <input type='radio' name='fetch_option' id="fetch_done_payments"/> Fetch Done Payments
                </div>
                <div className='col-md-2'>
                    <label>End Date</label>
                    <input type='date' className='form-control' id="end_date"/>
                </div>
                <div className='col-md-2'>
                    <label>Order Type</label>
                    <select className='form-control' id="order_type">
                        <option value="online">Online</option>
                        <option value="offline">Offline</option>
                        <option value="service">Service</option>
                    </select>
                </div>
                <div className='col-md-2'>
                    <label>Payment For</label>
                    <select className='form-control' id="payment_for">
                        <option value="supplier">Supplier</option>
                        <option value="vendor">Vendor</option>
                    </select>
                </div>
                <div className='col-md-2'>
                    <button type="button" className='btn btn-primary btn-sm mt-4' onClick={fetchSellerPayments}>Submit</button>
                </div>
                <div>
                <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                        <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                        <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                </div>
            </div>
            <br/>
            <table className="orders-table table-responsive report-margin commontop table-container">
                <thead>
                    <tr className='table-primary'>
                        <th></th>
                        <th>Reg Id</th>
                        <th>First Name</th>
                        <th>Middle Name</th>
                        <th>Last Name</th>
                        <th>Total Order Amount</th>
                        <th>Total Taxable Amount</th>
                        <th>Total TCS</th>
                        <th>Net Payment</th>
                        <th>Bank Name</th>
                        <th>Bank Account No</th>
                        <th>IFSC Code</th>
                        <th>View Order Details</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        sellerPayments.length > 0 ? 
                            sellerPayments.map((data) => {
                                return (
                                    <tr className='trtd'>
                                        <td>{
                                            !$('#fetch_done_payments').is(':checked') ? 
                                            <input type='checkbox' className='seller-payment-checkbox' onClick={(e) => addToPaymentList(e, data)}/>
                                            : null
                                            }
                                        </td>
                                        <td>{data.reg_id}</td>
                                        <td>{data.first_name}</td>
                                        <td>{data.middle_name}</td>
                                        <td>{data.last_name}</td>
                                        <td>{common.parseValue(data.total_order_amount, 'float')}</td>
                                        <td>{common.parseValue (data.total_taxable_amount, 'float')}</td>
                                        <td>{common.parseValue (data.total_tcs, 'float')}</td>
                                        <td>{common.parseValue (data.net_payment, 'float')}</td>
                                        <td>{data.bank_name}</td>
                                        <td>{data.bank_account_no}</td>
                                        <td>{data.ifsc_code}</td>
                                        <td><button type="button" className='btn btn-primary btn-sm' onClick={() => getOrderDetails(vendorPayment ? data.logistics_order_ids : data.order_item_ids, vendorPayment ? data.seller_id : 0)}>View Details</button></td>
                                    </tr>
                                )
                            })
                        :
                        "No Data"
                    }
                </tbody>
            </table>
            <br/>
            <>
            {
                approveButton ? 
                    <center><button type='button' className='btn btn-success btn-sm' id="approve-button" onClick={approvePayment}>Approve</button></center>
                : ""
            }
            {
                pushPaymentButton ? 
                    <center><button type='button' className='btn btn-success btn-sm' id="push-payment-button" onClick={() => setAddPaymentDate(!addPaymentDate)}>Mark as payment done</button></center>
                : ""
            }
            </>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>Order Details</ModalHeader>
                <ModalBody>
                <button className='btn button-product' onClick={handleExportCSVs}>Export to CSV</button>
                            <button className='btn button-product' onClick={handleExportExcels}>Export to Excel</button>
                            <button className='btn button-product' onClick={handleExportPDFs}>Export to PDF</button>
                <table className="orders-table table-responsive report-margin commontop table-container">
                    <thead>
                        <tr className='table-primary'>
                            <th>Order Id</th>
                            <th>Invoice No</th>
                            <th>Order Type</th>
                            <th>No Return Date</th>
                            <th>Product Name</th>
                            <th>Order Price</th>
                            <th>Order Status</th>
                            <th>Taxable Amount</th>
                            <th>Tax Percent</th>
                            <th>TAX</th>
                            <th>IGST Percent</th>
                            <th>IGST</th>
                            <th>CGST Percent</th>
                            <th>CGST</th>
                            <th>SGST Percent</th>
                            <th>SGST</th>
                            <th>UTGST Percent</th>
                            <th>UTGST</th>
                            <th>Marketing Charges</th>
                            <th>Discount</th>
                            <th>Other Charges</th>
                            <th>Shipment ID</th>
                            <th>Tracking No</th>
                            <th>TCS Rate</th>
                            <th>TCS</th>
                            <th>Bank Charges</th>
                            <th>Commission Charges</th>
                            <th>Return Logistics Order Price</th>
                            <th>Replace Logistics Order Price</th>
                            <th>Net Payment</th>
                            <th>Last Updated</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orderDetails.map((data) => {
                                // Calculate split lengths for each logistics type
                                const normalDiv = data?.logistics_order?.order_item_id?.split(',')?.length || 0;
                                const returnDiv = data?.return_logistics_order?.order_item_id?.split(',')?.length || 0;
                                const replaceDiv = data?.replace_logistics_order?.order_item_id?.split(',')?.length || 0;
                            
                                // Pick logistics source in order: normal > replace > return
                                const logisticsSource = data?.logistics_order || data?.replace_logistics_order || data?.return_logistics_order;
                            
                                // Dynamically assign the matching division count
                                let divisionNumber = 0;
                                if (logisticsSource?.id === data?.logistics_order?.id) divisionNumber = normalDiv;
                                else if (logisticsSource?.id === data?.replace_logistics_order?.id) divisionNumber = replaceDiv;
                                else if (logisticsSource?.id === data?.return_logistics_order?.id) divisionNumber = returnDiv;
                            
                                return (
                                    <tr className="trtd">
                                        <td>{data?.order?.order_id ?? 'NA'}</td>
                                        <td>
                                            {data?.order?.invoices
                                                ? (
                                                    data.order.invoices.find(invoice =>
                                                        vendorPayment ? invoice.invoice_type === "logistics" : invoice.invoice_type === "seller_product"
                                                    )?.invoice_no ?? ""
                                                )
                                                : ""}
                                        </td>
                                        <td>{data?.offline_sale_id ? 'Offline Sale' : data?.service_id ? 'Service Sale' : 'Online Sale'}</td>
                                        <td>{data?.no_return_date}</td>
                                        <td>{data?.product_item?.product?.name || data?.offline_sale_product_datum?.product_description || data?.seller_service?.service_name || 'NA'}</td>
                            
                                        <td>{vendorPayment ? Number(logisticsSource?.order_price || 0) / divisionNumber : data?.order_price ?? 0}</td>
                                        <td>{data?.order_status || null}</td>
                                        <td>{vendorPayment ? Number(logisticsSource?.taxable_value || 0) / divisionNumber : data?.taxable_amount ?? 0}</td>
                                        <td>{vendorPayment ? logisticsSource?.gst_rate ?? 0 : data?.tax_percent ?? 0}</td>
                                        <td>
                                            {common.parseValue (vendorPayment
                                                ? (Number(logisticsSource?.order_price || 0) - Number(logisticsSource?.taxable_value || 0)) / divisionNumber
                                                : (data?.order_price ?? 0) - (data?.taxable_amount ?? 0) , 'float')}
                                        </td>
                            
                                        <td>{vendorPayment ? logisticsSource?.igst_percent ?? 0 : data?.offline_sale_id ? data?.offline_sale_product_datum?.igst_rate ?? 0 : data?.igst_percent ?? 0}</td>
                                        <td>{vendorPayment ? Number(logisticsSource?.igst || 0) / divisionNumber : data?.offline_sale_id ? data?.offline_sale_product_datum?.igst_amount ?? 0 : data?.igst ?? 0}</td>
                            
                                        <td>{vendorPayment ? logisticsSource?.cgst_percent ?? 0 : data?.offline_sale_id ? data?.offline_sale_product_datum?.cgst_rate ?? 0 : data?.cgst_percent ?? 0}</td>
                                        <td>{vendorPayment ? Number(logisticsSource?.cgst || 0) / divisionNumber : data?.offline_sale_id ? data?.offline_sale_product_datum?.cgst_amount ?? 0 : data?.cgst ?? 0}</td>
                            
                                        <td>{vendorPayment ? logisticsSource?.sgst_percent ?? 0 : data?.offline_sale_id ? data?.offline_sale_product_datum?.sgst_utgst_rate ?? 0 : data?.sgst_percent ?? 0}</td>
                                        <td>{vendorPayment ? Number(logisticsSource?.sgst || 0) / divisionNumber : data?.offline_sale_id ? data?.offline_sale_product_datum?.sgst_utgst_amount ?? 0 : data?.sgst ?? 0}</td>
                            
                                        <td>{vendorPayment ? logisticsSource?.utgst_percent ?? 0 : data?.utgst_percent ?? 0}</td>
                                        <td>{vendorPayment ? Number(logisticsSource?.utgst || 0) / divisionNumber : data?.utgst ?? 0}</td>
                            
                                        <td>{vendorPayment ? null : data?.marketing_charges ?? 0}</td>
                                        <td>{vendorPayment ? null : data?.discount ?? 0}</td>
                                        <td>{vendorPayment ? null : data?.other_charges ?? 0}</td>
                            
                                        <td>{data?.shipment_id ?? 'NA'}</td>
                                        <td>{data?.tracking_no ?? 'NA'}</td>
                            
                                        <td>{vendorPayment ? logisticsSource?.tcs_rate ?? 0 : data?.tcs_rate ?? 0}</td>
                                        <td>{vendorPayment ? common.parseValue(Number(logisticsSource?.tcs || 0) / divisionNumber, 'float') : common.parseValue(data?.tcs ?? 0, 'float')}</td>
                                        <td>{vendorPayment ? common.parseValue(Number(logisticsSource?.bank_charges || 0) / divisionNumber, 'float') : common.parseValue(data?.bank_charges ?? 0, 'float')}</td>
                                        <td>{vendorPayment ? common.parseValue(Number(logisticsSource?.commission_charges || 0) / divisionNumber, 'float') : common.parseValue(data?.commission_charges ?? 0, 'float')}</td>
                            
                                        <td>
                                        {!vendorPayment
                                            ? returnDiv > 0 
                                            ? Number(data?.return_logistics_order?.order_price || 0) / returnDiv 
                                            : 0
                                            : 0}
                                        </td>
                                        <td>
                                        {!vendorPayment
                                            ? replaceDiv > 0 
                                            ? Number(data?.replace_logistics_order?.order_price || 0) / replaceDiv 
                                            : 0
                                            : 0}
                                        </td>
                            
                                        <td>{vendorPayment ? common.parseValue(Number(logisticsSource?.vendor_net_payment || 0) / divisionNumber, 'float') : common.parseValue(data?.supplier_net_payment ?? 0, 'float')}</td>
                                        <td>{data?.updated_at}</td>
                                    </tr>
                                );
                            })                            
                        }
                    </tbody>
                </table>
                </ModalBody>
            </Modal>

            <Modal isOpen={addPaymentDate} toggle={() => setAddPaymentDate(!addPaymentDate)} size="md">
                <ModalHeader toggle={() => setAddPaymentDate(!addPaymentDate)}>Add Payment Date</ModalHeader>
                <ModalBody>
                    <input type='datetime-local' id='payment-date' className='form-control' defaultValue={moment().seconds(0).format('YYYY-MM-DDTHH:mm')} max={moment().seconds(0).format('YYYY-MM-DDTHH:mm')}/><br/>
                    <button type='button' className='btn btn-success btn-sm' onClick={() => updatePaymentDate()}>Save</button>
                </ModalBody>
            </Modal>
        </>
  )
}

export default SellerPayments;